const Highcharts = require('highcharts');
const pieData = require('../home/performances/donut-data');
const geodata = require('../home/performances/geo-repartition-data');

$(function () {
  const colors = ['#7CCEB3', '#7CCEB3', '#7FB3E0', '#7FB3E0', '#7FB3E0', '#BBA7EB', '#BBA7EB', '#BBA7EB', '#F48AFF', '#F48AFF']
  let currentPieIndex = 0;
  const worldcolors = ['#7cceb3', '#7cceb3', '#7fb3e0', '#7fb3e0', '#7fb3e0', '#bba7eb','#bba7eb', '#bba7eb', '#f48aff', '#f48aff']

  /**
   * Data for geographical repartition map
   */
  let vals = [];

  $(pieData[9]).each(function (e) {
    vals.push({y: this.value, name: this.name})
  })

  const o2 = {
      title: {
        text: ""
      },
      credits: {
        enabled: false
      },
      colors: ['#36D693', '#FAA869', '#5C6B7E', '#E6808D', '#A468F1'],
      chart: {
        height : 215,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        type: 'pie',
        margin: [0, 0, 0, 0]
      },
      tooltip: {
        pointFormat: "<b>{point.percentage:.1f}%</b>"
      },
      plotOptions: {
        pie: {
          borderColor: "#ffffff",
          dataLabels: {
            enabled: false
          },
          showInLegend: false
        }
      },
      series: [{
        type: "pie",
        data: vals,
        innerSize: "16.7%"
      }]
  };
  const chart3 = Highcharts.chart('js-pie-chart', o2);

  const names = ['Profil 1 : Défensif 1', 'Profil 2 : Défensif 2', 'Profil 3 : Équilibré 1', 'Profil 4 : Équilibré 2', 'Profil 5 : Équilibré 3', 'Profil 6 : Offensif 1', 'Profil 7 : Offensif 2', 'Profil 8 : Offensif 3', 'Profil 9 : Agressif 1', 'Profil 10 : Agressif 2']

  const changeProfil = (idx) => {
    $('.profit__body__title').text(names[idx]);
    $('.profit__body__title').css({color : worldcolors[idx]});
    currentPieIndex = idx;
    vals = [];
    let x = 0;
    $(pieData[currentPieIndex]).each(function (e) {
      vals.push({y: this.value, name: this.name});
      $('.chart-legend li').eq(x).find('.chart-legend__text').text(this.value + "%");
      x++;
    })

    chart3.series[0].setData(vals)

    const current = geodata[currentPieIndex];
    x = 0;
    const mapLabels = $('.world-chart__region');

    $('.world-chart-labels__row').each(function() {
      // Map values
      // Apply the percentage to get new circle size min 15px max 40px
      const circleSize = Math.ceil(40 * (current[x].value * 0.01 ) + 15)
      $(mapLabels[x]).text(current[x].value + '%');
      $(mapLabels[x]).css('width', circleSize).css('height', circleSize)

      // World region
      $('.world-chart__region--' + current[x].id).text(current[x].value + '%');
      $('.world-chart__region--' + current[x].id).text(current[x].value + '%');
      $(this).find('.world-chart-labels__row__head__amount').text(current[x].value + '%');
      $(this).find('.world-chart-labels__row__bar__fill').css({width : current[x].value + '%'})
      x++;
    })
  }

  $('.-js-change-profit').on('change', 'input', function (e) {
    e.preventDefault();
    changeProfil($(this).parent().index())
  })

  changeProfil(9)
})
